

































import { Component, Vue, Prop } from "vue-property-decorator";
import ThinLineAnimation from "@/components/ThinLineAnimation";
import { InteractionData } from "@/types";
import { flatMap, max } from "lodash";

@Component({
  name: "BusinessInteraction",

  components: {
    ThinLineAnimation,
  },
})
export default class BusinessInteraction extends Vue {
  @Prop({ type: Array, required: true }) items!: Array<InteractionData>;

  get maxValue() {
    return max(
      flatMap(this.items, (item: any) => [item.smePct, item.expertPct])
    );
  }

  lineBackgrounds: Array<string> = [
    "linear-gradient(270deg, #D7E8C7 41.83%, rgba(215, 232, 199, 0.48) 82.07%)",
    "linear-gradient(90deg, #99908B 0%, #3C5E73 100%)",
  ];
}
